import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import styles from './NavItem.module.scss';

const NavItem = ({
  name,
  iconName,
  url,
}) => {
  const [imageError, setImageError] = useState(false);

  const itemStyle = classNames({
    [styles.item]: true,
    [styles['item--casino']]: iconName === 'casino',
  });

  const handleImageError = () => {
    setImageError(true);
  };

  const imageSrc = imageError
    ? '/assets/images/icons/icon-sport-svg/default.svg'
    : `/assets/images/icons/icon-sport-svg/${iconName}.svg`;

  return (
    <Link
      title={name}
      to={url}
      data-hook={`left-nav-${iconName}`}
      className={itemStyle}
    >
      {iconName !== 'casino' &&
        <img
          src={imageSrc}
          alt={name}
          className={styles.icon}
          onError={handleImageError}
        />
      }
      <span className={styles.text}>
        {name}
      </span>
    </Link>
  );
};

NavItem.propTypes = {
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  iconName: PropTypes.string.isRequired,
};

export default NavItem;
